"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var material_1 = require("@mui/material");
var makeIconTileCheckBoxStyling = function (_a) {
    var _b;
    var showText = _a.showText, isSubtextPresent = _a.isSubtextPresent, minHeight = _a.minHeight;
    var _c = (0, react_1.useTheme)(), breakpoints = _c.breakpoints, mvf = _c.mvf;
    var palette = mvf.palette, spacing = mvf.spacing;
    return {
        container: (0, react_1.css)(__assign(__assign(__assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }, (minHeight && {
            minHeight: minHeight,
        })), (!minHeight && {
            height: '100%',
        })), { '& .MuiTypography-root': __assign({ marginBottom: 14 }, (isSubtextPresent && {
                marginTop: 0,
                marginBottom: 0,
                paddingBottom: 2,
                paddingTop: 2,
            })) })),
        icon: (0, react_1.css)(__assign(__assign({}, (showText && __assign({ marginBottom: 4, marginTop: 4 }, (!isSubtextPresent && {
            marginTop: 12,
        })))), (_b = { '& img': {
                    height: 35,
                } }, _b[breakpoints.up('mobileMedium')] = {
            '& img': {
                height: 39,
            },
        }, _b[breakpoints.up('mobileLarge')] = {
            '& img': {
                height: 42,
            },
        }, _b[breakpoints.up('tabletSmall')] = {
            '& img': {
                height: 43,
            },
        }, _b[breakpoints.up('tabletMedium')] = {
            '& img': {
                height: 54,
            },
        }, _b[breakpoints.up('desktopMedium')] = {
            '& img': {
                height: 65,
            },
        }, _b))),
        checkbox: (0, react_1.css)({
            color: palette.component.answerUnselectedColor,
            position: 'absolute',
            '&.Mui-checked': {
                display: 'inline-flex',
            },
            '&.MuiIconButton-root': {
                '@media (hover: hover)': {
                    '&:hover': {
                        backgroundColor: (0, material_1.alpha)(palette.component.answerSelectedColor, 0.04),
                    },
                },
            },
        }),
        otherInput: (0, react_1.css)({
            marginLeft: spacing.small,
            marginRight: spacing.small,
            paddingBottom: spacing.small,
            '& .MuiFilledInput-root': {
                boxShadow: 'none',
            },
        }),
        imgDiv: (0, react_1.css)({
            display: 'flex',
            justifyContent: 'center',
        }),
    };
};
exports.default = makeIconTileCheckBoxStyling;
//# sourceMappingURL=makeIconTileCheckBoxStyling.js.map